
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy/ultra",
      function () {
        return require("private-next-pages/buy/ultra.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy/ultra"])
      });
    }
  